import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface GradientWashProps {
    variant?: 'hero' | 'soft' | 'panel'
    className?: string
}

const PEACH = 'radial-gradient(closest-side, rgba(255, 186, 156, 0.6), rgba(255, 186, 156, 0))'
const LAVENDER = 'radial-gradient(closest-side, rgba(204, 190, 252, 0.5), rgba(204, 190, 252, 0))'
const CREAM = 'radial-gradient(closest-side, rgba(255, 224, 196, 0.65), rgba(255, 224, 196, 0))'

/**
 * Slow-drifting cream, peach and lavender wash. Strongest behind heroes,
 * fading to flat cream towards the content below.
 */
export const GradientWash: FC<GradientWashProps> = ({ variant = 'hero', className }): ReactNode => {
    return (
        <div
            aria-hidden='true'
            className={cn(
                'pointer-events-none absolute inset-0 -z-10 overflow-hidden',
                variant === 'soft' && 'opacity-60',
                className
            )}
        >
            <div
                className='absolute -right-[12%] -top-[22%] h-[78%] w-[62%] animate-wash-a'
                style={{ background: PEACH }}
            />

            <div
                className='absolute -left-[18%] top-[2%] h-[70%] w-[58%] animate-wash-b'
                style={{ background: LAVENDER }}
            />

            <div
                className='absolute left-[22%] top-[26%] h-[60%] w-[56%] animate-wash-c'
                style={{ background: CREAM }}
            />

            {variant !== 'panel' && (
                <div className='absolute inset-x-0 bottom-0 h-[55%] bg-gradient-to-b from-cream/0 to-cream' />
            )}
        </div>
    )
}
